export default {"src":"/_next/static/media/lo-white.c559d802.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};